import axios from 'axios'
import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { captchaAxios } from 'api/config'
import { Agent, AgentInputRequirement } from 'types/agent'
import { store } from 'store'
import { settingsSelectors } from 'store/settings'
import { buildAgentInputs } from 'utils/agent-inputs'
import { audioPlayer } from 'services/audio-player'
import { voiceAnswerByChat } from 'api/index'

export const getAgentsParams = async (chatId: string): Promise<AgentInputRequirement[]> => {
  const { data } = await captchaAxios.get<AgentInputRequirement[]>(`chats/${chatId}/agents/params`)
  return Array.isArray(data) ? data : []
}

export const confirmAgentAction = async ({
  chatId,
  runId,
  approved,
}: {
  chatId: string
  runId: string
  approved: boolean
}): Promise<void> => {
  const inputs = buildAgentInputs(store.getState())
  // The continuation streams onto the paused answer: if that answer was spoken, keep speaking.
  // Before the first await, so it still runs inside the approve/reject click (autoplay grant).
  const voiceAnswerId = voiceAnswerByChat.get(chatId)
  if (voiceAnswerId) {
    audioPlayer.unlock()
    audioPlayer.expect(voiceAnswerId)
  }
  await captchaAxios.post(`chats/${chatId}/agent/confirm`, {
    runId,
    approved,
    inputs,
    ...(voiceAnswerId && { voice: true }),
  })
}

export const AGENTS_QUERY_KEY = 'agents'

// Needs the user's token (arrives via postMessage in external mode), so the query waits for login.
export const useGetAgents = () => {
  const isLogged = useSelector(settingsSelectors.isLogged)
  return useQuery({
    queryKey: [AGENTS_QUERY_KEY],
    queryFn: async () => (await axios.get<Agent[]>('agents/available')).data,
    enabled: isLogged,
  })
}
